// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__23zY2","card_status":"styles_card_status__2L1Wy","card_status_value":"styles_card_status_value__2nyV5"};